import { SubscriptionPlanName } from '@sparemin/api-sdk';
import cn from 'classnames';
import React from 'react';
import { VideoCameraAlt2 } from 'components/icons';
import SubPeriodPlanHeader, {
  SubPeriodPlanHeaderProps,
} from '../SubPeriodPlanHeader';
import { basicPlanBlock as block } from '../utils';

export interface BasicPlanHeaderProps
  extends Pick<
    SubPeriodPlanHeaderProps,
    'previousCost' | 'period' | 'isLimitedTime'
  > {
  className?: string;
  density?: 'sparse' | 'comfortable';
}

const BasicPlanHeader: React.FC<BasicPlanHeaderProps> = ({
  className,
  density = 'sparse',
  previousCost,
  period,
  isLimitedTime,
}) => (
  <SubPeriodPlanHeader
    {...{ previousCost, period, isLimitedTime }}
    className={cn(block('header', { [density]: true }), className)}
    density={density}
    cost={{
      monthly: SubscriptionPlanName.BASIC_20250818_MONTHLY,
      yearly: SubscriptionPlanName.BASIC_20250818_YEARLY,
    }}
    description="Take your podcast promotion to the next level with more features."
    icon={<VideoCameraAlt2 icon="video" className={block('header-icon')} />}
    theme="basic"
    title="Basic"
  />
);

export default BasicPlanHeader;
